import { PipeTransform, Pipe } from "@angular/core";

@Pipe({
  name: 'valueId'
})
export class ValueIdPipe implements PipeTransform {
  transform(values: any[]): string[] {
    return values.map(v => v.id);
  }
}